import type { ReactNode } from 'react'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import cn from 'classnames'
import { Children, cloneElement, isValidElement } from 'react'

// Wraps plain-text children (e.g. "Home") in a Typography element so they can be styled
// consistently with children that are already explicit Typography elements.
export function wrapTextChildrenWithTypography(children: ReactNode) {
  return Children.map(children, child => (isValidElement(child) ? child : <Typography>{child}</Typography>))
}

// Applies className to every rendered Typography child, whether it was auto-wrapped from
// plain text via wrapTextChildrenWithTypography or passed in explicitly by the consumer.
export function withTypographyClassName(children: ReactNode, className: string) {
  return Children.map(children, (child) => {
    if (isValidElement<{ className?: string }>(child) && child.type === Typography)
      return cloneElement(child, { className: cn(className, child.props.className) })

    return child
  })
}
